












































import { defineComponent, onMounted, ref } from "@vue/composition-api";
import logger from "@/modules/logger";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "PageError",
  components: { BaseButton },
  props: {
    error: { type: Error, required: true },
  },
  setup(props) {
    const expanded = ref(false);

    onMounted(() => {
      logger.debug(props.error, undefined);
    });

    return { expanded };
  },
});
